import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { QualityApprovalService } from '../../../service/api/qualityapproval-service';
import { showToast } from 'Core/redux/toast/slice';
import { closeModal, showModal } from 'Core/redux/main/slice';
import { redux } from 'Core/redux';
import { saveAs } from 'Core/utils';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { selectStatusLoading } from '../../../core/redux/status/selectors';

const { QUALITYAPPROVAL_ADD_EDIT } = MODAL_TYPES;

export const STORE_KEY = 'qualityapproval';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  filters: {
    searchText: '',
    status: {
      value: 'In Production',
      label: 'In Production',
    },
    // startDate: null,
    // endDate: null,
  },
  qualityApprovalDataFilters: {
    searchText: '',
  },
  qualityApprovalDataSortKey: {
    value: 'categoryName',
    label: 'Sort By Category',
  },
  filterVisible: false,
  tileView: true,
  selectedQualityApproval: null,
  editModalVisible: false,
  approvalData: null,
};

export const fetchQualityApprovals = createAsyncThunk(
  'qualityapproval/fetchQualityApprovals',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.getAllApprovals(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load Quality Approvals');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Quality Approvals');
    }
  },
);

export const approveRejectQualityApproval = createAsyncThunk(
  'qualityapproval/approveRejectQualityApproval',
  async (reqBody, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.approveRejectQualityApproval(reqBody);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to act on Quality');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to act on Quality');
    }
  },
);

export const requestEvidenceQualityApproval = createAsyncThunk(
  'qualityapproval/requestEvidenceQualityApproval',
  async (reqBody, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.requestEvidence(reqBody);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to request evidence',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to request evidence');
    }
  },
);

export const addQualityApproval = createAsyncThunk(
  'qualityapproval/addQualityApproval',
  async (qualityApprovalPayload, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.createQualityApproval(qualityApprovalPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to add Inspection Plans');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Inspection Plans');
    }
  },
);

export const editQualityApproval = createAsyncThunk(
  'qualityapproval/editQualityApproval',
  async (qualityApprovalPayload, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.createQualityApproval(qualityApprovalPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to update qualityApproval',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update qualityApproval');
    }
  },
);

export const extendQualityApproval = createAsyncThunk(
  'qualityapproval/extendQualityApproval',
  async (qualityApprovalPayload, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.extendQualityApproval(qualityApprovalPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to update qualityApproval',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update qualityApproval');
    }
  },
);

export const downloadqualityApprovals = createAsyncThunk(
  'qualityapproval/downloadQualityApprovals',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.downloadQualityApproval(filters);
      const blob = response;
      saveAs(blob, `QualityApprovals.xlsx`);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to download Inspection Plans');
    }
  },
);

export const deleteQualityApprovals = createAsyncThunk(
  'qualityapproval/deleteQualityApproval',
  async (qualityApprovalsId, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.deleteQualityApprovals(qualityApprovalsId);
      if (response.status === 200) {
        return qualityApprovalsId;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to delete qualityApproval',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete qualityApproval');
    }
  },
);

export const fetchQualityApprovalsWithFilters = () => (dispatch, getState) => {
  const filters = getState().qualityapproval.filters;
  dispatch(
    fetchQualityApprovals({
      // searchText: filters.searchText,
      // customer: filters?.customer?.value,
      status: filters?.status?.value,
      // qualityApprovalDate: filters?.shipDate,
    }),
  );
};

export const downloadQualityApprovalsWithFilters = () => (dispatch, getState) => {
  const filters = getState().qualityapproval.filters;
  dispatch(
    downloadqualityApprovals({
      searchText: filters.searchText,
      customer: filters?.customer?.value,
      status: filters?.status?.value,
      qualityApprovalDate: filters?.shipDate,
    }),
  );
};

export const fetchQualityApprovalData = createAsyncThunk(
  'qualityapproval/fetchQualityApprovalData',
  async (qualityApproval, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.getQualityApprovalById(qualityApproval.id);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load shipment data');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load shipment data');
    }
  },
);

export const quarantineQualityApproval = createAsyncThunk(
  'qualityapproval/quarantineinv',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.Quarantine(payload);
      if (response.status === 200) {
        return payload;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to quarantine');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to quarantine');
    }
  },
);

export const releaseQualityApproval = createAsyncThunk(
  'qualityapproval/releaseinv',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await QualityApprovalService.Release(payload);
      if (response.status === 200) {
        return payload;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to release qualityApproval',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to release qualityApproval');
    }
  },
);

export const fetchApprovals = createAsyncThunk('status/fetchApprovals', async () => {
  const { response } = await QualityApprovalService.getAllApprovals();
  return response;
});

export const { reducer, actions, caseReducers } = createSlice({
  name: 'qualityApproval',
  initialState: INITIAL_STATE,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetFilters: state => {
      state.filters = INITIAL_STATE.filters;
    },
    setSelectedPart: (state, action) => {
      state.selectedQualityApproval = action.payload;
    },
    setFilterVisible: (state, action) => {
      state.filterVisible = action.payload;
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setQualityApprovalDataFilters: (state, action) => {
      state.qualityApprovalDataFilters.searchText = action.payload;
    },
    setQualityApprovalSortKey: (state, action) => {
      state.qualityApprovalDataSortKey = action.payload;
    },
    setCustomer: (state, action) => {
      state.filters.customer = action.payload;
    },
    setStatus: (state, action) => {
      state.filters.status = action.payload;
    },
    setStartDate: (state, action) => {
      state.filters.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.filters.endDate = action.payload;
    },
    setTileView: (state, action) => {
      state.tileView = action.payload; // Add reducer to update tileView
    },
    updateQualityApprovalData: (state, action) => {
      state.qualityApprovalData = action.payload;
      console.log(action.payload);
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchApprovals.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovals.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApprovals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchQualityApprovals.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQualityApprovals.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchQualityApprovals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addQualityApproval.fulfilled, (state, action) => {
        const newQualityApproval = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newQualityApproval, ...state.data];
      })
      .addCase(addQualityApproval.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(extendQualityApproval.fulfilled, (state, action) => {
        const newQualityApproval = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newQualityApproval, ...state.data];
      })
      .addCase(extendQualityApproval.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(editQualityApproval.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editQualityApproval.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchQualityApprovalData.pending, state => {
        state.qualityApprovalLoading = true;
        state.qualityApprovalError = null;
      })
      .addCase(fetchQualityApprovalData.fulfilled, (state, action) => {
        state.qualityApprovalLoading = false;
        state.qualityApprovalData = action.payload;
      })
      .addCase(fetchQualityApprovalData.rejected, (state, action) => {
        state.qualityApprovalLoading = false;
        state.qualityApprovalError = action.payload;
      })
      .addCase(approveRejectQualityApproval.pending, state => {
        state.approvalLoading = true;
        state.approvalError = null;
      })
      .addCase(approveRejectQualityApproval.fulfilled, (state, action) => {
        state.approvalLoading = false;
        state.approvalData = action.payload;
      })
      .addCase(approveRejectQualityApproval.rejected, (state, action) => {
        state.approvalLoading = false;
        state.approvalError = action.payload;
      })
      .addCase(requestEvidenceQualityApproval.pending, state => {
        state.approvalLoading = true;
        state.approvalError = null;
      })
      .addCase(requestEvidenceQualityApproval.fulfilled, (state, action) => {
        state.approvalLoading = false;
        state.approvalData = action.payload;
      })
      .addCase(requestEvidenceQualityApproval.rejected, (state, action) => {
        state.approvalLoading = false;
        state.approvalError = action.payload;
      })
      .addCase(deleteQualityApprovals.fulfilled, (state, action) => {
        const newData = state.data.filter(s => s.id !== action.payload);
        state.data = newData;
      });
  },
});

export const updateQualityApprovalDataWithComment =
  (requestId, comments, modalId) => (dispatch, getState) => {
    const qualityApprovalData = getState().qualityapproval.qualityApprovalData;
    const updatedData = qualityApprovalData.map(qaObj => {
      return qaObj.requestId == requestId
        ? {
            ...qaObj,
            comments: comments,
          }
        : qaObj;
    });
    dispatch(actions.updateQualityApprovalData(updatedData));
    //dispatch(updateModalData(modalId,updatedData));
  };

redux.listener.startListening({
  matcher: isAnyOf(
    addQualityApproval.rejected,
    editQualityApproval.rejected,
    fetchQualityApprovalData.rejected,
    quarantineQualityApproval.rejected,
    releaseQualityApproval.rejected,
    extendQualityApproval.rejected,
    approveRejectQualityApproval.rejected,
    requestEvidenceQualityApproval.rejected,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload,
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    addQualityApproval.fulfilled,
    extendQualityApproval.fulfilled,
    editQualityApproval.fulfilled,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(QUALITYAPPROVAL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'QualityApproval saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(quarantineQualityApproval.fulfilled, releaseQualityApproval.fulfilled),
  effect: (action, listenerApi) => {
    selectStatusLoading(false);
    listenerApi.dispatch(
      showToast({
        message: 'QualityApproval saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    addQualityApproval.fulfilled,
    extendQualityApproval.fulfilled,
    editQualityApproval.fulfilled,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(QUALITYAPPROVAL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'QualityApproval saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(fetchQualityApprovalData.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(showModal(QUALITYAPPROVAL_ADD_EDIT, action.payload));
  },
});

redux.listener.startListening({
  matcher: isAnyOf(approveRejectQualityApproval.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'Action successful',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(requestEvidenceQualityApproval.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload?.message || 'Evidence requested successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(deleteQualityApprovals.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'QualityApproval deleted successfully',
        type: 'success',
      }),
    );
  },
});

redux.injectReducer(STORE_KEY, reducer);
